(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-categories"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // Function to set up dropdown toggle behavior
    function setupDropdown($main, btnClass, dropdownClass) {
      var $btn = $main.find(btnClass);
      var $dropdown = $main.find(dropdownClass);

      function toggleDropdown(forceOpen = false) {
        var isExpanded = $btn.attr('aria-expanded') === 'true';

        if (forceOpen || !isExpanded) {
          $btn.attr('aria-expanded', 'true');
          $dropdown.addClass('show').show();
        } else {
          $btn.attr('aria-expanded', 'false');
          $dropdown.removeClass('show').hide();
        }
      }

      if ($btn.length && $dropdown.length) {
        // Click event for toggle
        $btn.on('click', function() {
          toggleDropdown();
        });

        // Keyboard event for accessibility (Enter or Space)
        $btn.on('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleDropdown();
          }
        });
      }

      // Return toggle function for external use (e.g., hero button)
      return toggleDropdown;
    }

    // Set up dropdown for Category 1
    setupDropdown($('.category-btn1-main'), '.category-btn1', '.dropdown-category-1');

    // Set up dropdown for Category 2 and store toggle function
    var toggleCategory2 = setupDropdown($('.category-btn2-main'), '.category-btn2', '.dropdown-category-2');

    // Scroll + open when hero button clicked (specific to Category 2)
    $('.hero-scroll-btn').on('click', function(e) {
      e.preventDefault();
      var $main = $('.category-btn2-main');
      var targetSection = $main.offset().top - 250; // Adjust for header space

      $('html, body').animate({ scrollTop: targetSection }, 800, function() {
        toggleCategory2(true); // Force dropdown open after scroll
      });
    });

    // Search Functionality (unchanged)
    var $searchInput = $('#category-search');
    var $categoryCards = $('.home-categories-width2-child');

    function filterCategories() {
      var searchText = $searchInput.val().toLowerCase();

      $categoryCards.each(function() {
        var $card = $(this);
        var categoryName = $card.find('h3').text().toLowerCase();
        var matchesSearch = categoryName.includes(searchText);

        $card.toggle(matchesSearch);
      });
    }

    if ($searchInput.length) {
      $searchInput.on('input', filterCategories);

      $searchInput.on('keydown', function(e) {
        if (e.key === 'Enter') {
          filterCategories();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
